// Registers the Aurora custom elements. Imported by app.module.ts and .storybook/preview.ts so both use one list.
import { AuroraHeader } from '@insurity/aurora-lit/components/aurora-header';
import '@insurity/aurora-lit/components/aurora-avatar';
import '@insurity/aurora-lit/components/aurora-badge';
import '@insurity/aurora-lit/components/aurora-banner';
import '@insurity/aurora-lit/components/aurora-button';
import '@insurity/aurora-lit/components/aurora-checkbox';
import '@insurity/aurora-lit/components/aurora-chip';
import '@insurity/aurora-lit/components/aurora-dropdown';
import '@insurity/aurora-lit/components/aurora-icon';
import '@insurity/aurora-lit/components/aurora-icon-button';
import '@insurity/aurora-lit/components/aurora-input-text-single';
import '@insurity/aurora-lit/components/aurora-label';
import '@insurity/aurora-lit/components/aurora-link-button';
import '@insurity/aurora-lit/components/aurora-loading-indicator';
import '@insurity/aurora-lit/components/aurora-menu';
import '@insurity/aurora-lit/components/aurora-modal';
import '@insurity/aurora-lit/components/aurora-navbar';
import '@insurity/aurora-lit/components/aurora-popover';
import '@insurity/aurora-lit/components/aurora-radio';
import '@insurity/aurora-lit/components/aurora-segmented-button';
import '@insurity/aurora-lit/components/aurora-split-button';
import '@insurity/aurora-lit/components/aurora-stepper';
import '@insurity/aurora-lit/components/aurora-toggle';

// Unlike every other aurora element, aurora-header's customElements.define lives in a root-level
// module that falls outside the package's `sideEffects: ["**/components/**"]` globs, so a bare
// side-effect import is tree-shaken out of optimized builds and the tag never upgrades. Touching
// the exported class at runtime keeps the registration in the bundle.
if (!customElements.get('aurora-header')) {
    customElements.define('aurora-header', AuroraHeader);
}
